import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { urlJoin } from '../../../../core/helpers/url.helper';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../app.config';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ChatMessageRequest, ChatMessageResponse, ChatResponse, Sender } from './messaging.model';
import { Message } from '@tribeauto/ngx-mobilite-material';
import { chatMessageRequestToMessage, getMessageListFromChatMessageResponse } from './messaging.component.mapper';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);

  private readonly url = urlJoin(this.appConfig.url, 'contract');
  lastMessageList: WritableSignal<Message[]> = signal([]);
  lastNotificationsCount = signal(0);
  lastChatMessageResponseListError = signal(null);

  getChatMessages(numAuto: string): Observable<Message[]> {
    return this.httpClient.get<ChatResponse>(urlJoin(this.url, numAuto, 'chats', 'messages')).pipe(
      map((response: ChatResponse) => {
        const chatMessageResponseList = response?.chatMessageResponseList ? response.chatMessageResponseList : [];
        this.lastNotificationsCount.set(
          chatMessageResponseList.filter(
            chatMessageResponse => chatMessageResponse.sender === Sender.MIDDLE && !chatMessageResponse.read
          ).length
        );
        const messageList = getMessageListFromChatMessageResponse(chatMessageResponseList);
        this.lastMessageList.set(messageList);
        this.lastChatMessageResponseListError.set(null);
        return messageList;
      }),
      catchError(error => {
        this.lastChatMessageResponseListError.set(error);
        return throwError(() => error);
      })
    );
  }

  saveChatMessage(numAuto: string, chatMessageRequest: ChatMessageRequest): Observable<void> {
    const lastMessageList = this.lastMessageList();
    const newMessageList = [
      ...lastMessageList,
      chatMessageRequestToMessage(
        chatMessageRequest,
        lastMessageList.length > 0 ? lastMessageList[lastMessageList.length - 1].id + 1 : 0
      )
    ];
    this.lastMessageList.set(newMessageList);
    return this.httpClient.post<void>(urlJoin(this.url, numAuto, 'chats', 'message'), chatMessageRequest).pipe(
      catchError(error => {
        this.lastMessageList.set(lastMessageList);
        return throwError(() => error);
      })
    );
  }

  markMessagesAsRead(numAuto: string): Observable<void> {
    return this.httpClient.patch<void>(urlJoin(this.url, numAuto, 'chats', 'messages', 'read'), {});
  }
}
